import { action } from 'easy-peasy';
import { IActionRemoveCrisisCall } from '../types';

const removeCrisisCall: IActionRemoveCrisisCall = action((state, { crisisCallId }) => {
  state.crisisCalls = state.crisisCalls.filter(
    crisisCall => crisisCall.crisisCallId !== crisisCallId,
  );
});

export default removeCrisisCall;
